import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { TOPIC_LINKS } from "@/pages/seo/seoContent";

const TOPIC_FOOTER_LINKS = TOPIC_LINKS.map(({ to, label }) => ({ to, label }));

export function SiteFooter() {
  return (
    <footer className="border-t border-border bg-[#F7F8FA]">
      <div className="max-w-7xl mx-auto px-6 pt-16 pb-10">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-3 max-w-md">
            <div className="sm:scale-110 sm:origin-left">
              <Logo />
            </div>
            <p className="mt-5 text-[13.5px] text-muted-foreground leading-[1.7]">
              Liftblick.ch ist eine Schweizer Plattform für Liftanfragen. Kunden erfassen ihr Liftprojekt online. Registrierte Liftanbieter können passende Anfragen im Portal einsehen und direkt Kontakt aufnehmen.
            </p>
          </div>

          <nav className="md:col-span-2 flex flex-col items-start gap-2.5 self-start text-[13.5px]" aria-label="Footer Plattform">
            <p className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground font-medium mb-2">
              Plattform
            </p>
            <Link to="/wizard" className="text-muted-foreground hover:text-foreground transition-colors">Liftanfrage erfassen</Link>
            <Link to="/#so-funktioniert" className="text-muted-foreground hover:text-foreground transition-colors">So funktioniert es</Link>
            <Link to="/liftarten" className="text-muted-foreground hover:text-foreground transition-colors">Liftarten</Link>
            <Link to="/faq" className="text-muted-foreground hover:text-foreground transition-colors">FAQ</Link>
            <Link to="/kontakt" className="text-muted-foreground hover:text-foreground transition-colors">Kontakt</Link>
            <Link to="/fuer-anbieter" className="text-muted-foreground hover:text-foreground transition-colors">Für Anbieter</Link>
          </nav>

          <nav className="md:col-span-5 self-start text-[13.5px]" aria-label="Footer Liftthemen">
            <p className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground font-medium mb-4">
              Liftthemen
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-2.5">
              {TOPIC_FOOTER_LINKS.map(({ to, label }) => (
                <Link key={to} to={to} className="text-muted-foreground hover:text-foreground transition-colors">
                  {label}
                </Link>
              ))}
            </div>
          </nav>




          <nav className="md:col-span-2 flex flex-col items-start gap-2.5 self-start text-[13.5px]" aria-label="Footer Rechtliches">
            <p className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground font-medium mb-2">
              Rechtliches
            </p>
            <Link to="/impressum" className="text-muted-foreground hover:text-foreground transition-colors">Impressum</Link>
            <Link to="/datenschutz" className="text-muted-foreground hover:text-foreground transition-colors">Datenschutz</Link>
            <Link to="/agb" className="text-muted-foreground hover:text-foreground transition-colors">AGB</Link>
            <button
              type="button"
              onClick={() => window.dispatchEvent(new Event("openCookieSettings"))}
              className="text-left text-muted-foreground hover:text-foreground transition-colors"
            >
              Cookie-Einstellungen
            </button>
          </nav>
        </div>

        <div className="mt-14 pt-6 flex flex-col sm:flex-row justify-between gap-3 text-[11.5px] text-muted-foreground">
          <p>© {new Date().getFullYear()} Liftblick.ch - Schweizer Plattform für Liftanfragen.</p>
          <p>Aufzüge, Homelifte, Treppenlifte, Wartung und Modernisierung.</p>
        </div>
      </div>
    </footer>
  );
}
